__turbopack_context__.v({
  "affirmMessage": "AffirmMessage-module-scss-module__DWZoMW__affirmMessage",
});
